export default "__VITE_ASSET__79ffa1fc__"